export default __webpack_public_path__ + "static/media/careers-at-ojo.b84341c7.jpg";